import React from "react";

// Stella's 4-point north star mark.
export default function StellaLogo({ className = "w-6 h-6", withGlow = false }) {
  return (
    <span className={`inline-flex relative ${withGlow ? "drop-shadow-[0_0_18px_rgba(109,40,217,0.35)]" : ""}`}>
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z"/>
      </svg>
    </span>
  );
}
